module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "decoration-frame"
  }, [_c('div', [_c('div', [_c('span', {
    staticClass: "thin"
  }, [_vm._v("ARCHITECTE")]), _vm._v(" "), _c('span', {
    staticClass: "sep"
  }, [_vm._v("/")]), _vm._v(" LOGICIEL")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("12 ans d'expérience")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-599a0a69"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Decoration.vue
// module id = 47
// module chunks = 0